function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { formatDate } from 'helpers/datetime';
import App from 'modules/App';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import styles from './ChoosePatient.pcss';
const placeholder = 'N/A';
const EntryValue = ({ value })=>/*#__PURE__*/ _jsx("p", {
        className: cn(styles.patientData__value, {
            [styles['patientData__value--placeholder']]: !value
        }),
        children: value || placeholder
    });
const Entry = ({ value, labelMessage })=>/*#__PURE__*/ _jsxs("div", {
        className: styles.patientData__entry,
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: styles.patientData__label,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, labelMessage))
            }),
            /*#__PURE__*/ _jsx(EntryValue, {
                value: value
            })
        ]
    });
const PatientData = ({ firstName, lastName, dateOfBirth, gender })=>{
    const clinicPatientTemplate = useSelector(selectors.clinicPatientTemplate);
    const localizationResources = useSelector(App.selectors.localizationResources);
    const localizedDateOfBirth = formatDate(dateOfBirth);
    const genderFieldDef = clinicPatientTemplate.find((ft)=>ft.name === 'gender');
    const option = genderFieldDef.options.find((opt)=>opt.value === gender);
    const localizedGender = option && localizationResources[option.labelKey].value;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.patientData,
        children: [
            /*#__PURE__*/ _jsx(Entry, {
                value: firstName,
                labelMessage: messages.labels.firstName
            }),
            /*#__PURE__*/ _jsx(Entry, {
                value: lastName,
                labelMessage: messages.labels.lastName
            }),
            /*#__PURE__*/ _jsx(Entry, {
                value: localizedGender,
                labelMessage: messages.labels.gender
            }),
            /*#__PURE__*/ _jsx(Entry, {
                value: localizedDateOfBirth,
                labelMessage: messages.labels.dateOfBirth
            })
        ]
    });
};
export default PatientData;
